<template lang="pug">
    #load-indicator
        span.icon
            i.fa.fa-spinner.fa-pulse
        span.text {{ text }} loading...
</template>

<script>
export default {
  name: "LoadIndicator",
  props: {
    list: Array
  },
  computed: {
    text() {
      return this.list.join(", ");
    }
  }
};
</script>

<style lang="scss" scoped>
#load-indicator {
  position: fixed;
  background-color: #3a4750;
  color: $defaultColor;
  display: flex;
  padding: 0.5rem 0;

  .icon {
    margin: 0 0.5rem;
  }
}
</style>
